import { useEffect, useState } from "react";
import { getEmergencyContactApi, updateEmergencyContactApi } from "../../api/core";
import { IEmergencyContact } from "../../interface/emergency-contact";
import { setAppLoading } from "../../redux/app.reducer";
import { useAppDispatch } from "../../redux/hooks";
import useSnackbar from "../../utils/snackbar";

const SettingEmergencyContact = () => {
  const dispatch = useAppDispatch();
  const [openSnackbar] = useSnackbar({ position: "bottom-left" });
  const [emergencyContact, setEmergencyContact] = useState<IEmergencyContact>({
    phoneNumber: "",
    label: "",
    description: "",
    isActive: true,
  });
  const [loading, setLoading] = useState(false);

  const getEmergencyContact = async () => {
    try {
      setLoading(true);
      const { data } = await getEmergencyContactApi();
      setEmergencyContact(data);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      let msg: string | undefined;
      if (typeof e?.response?.data?.message === "string") {
        msg = e?.response?.data?.message;
      }
      openSnackbar(msg || "Error: Something wrong.");
    }
  };

  const updateEmergencyContact = async (payload: IEmergencyContact) => {
    try {
      setLoading(true);
      const { data } = await updateEmergencyContactApi(payload);
      setEmergencyContact(data);
      setLoading(false);
      openSnackbar("Successfuly");
    } catch (e: any) {
      setLoading(false);
      let msg: string | undefined;
      if (typeof e?.response?.data?.message === "string") {
        msg = e?.response?.data?.message;
      }
      openSnackbar(msg || "Error: Something wrong.");
    }
  };

  useEffect(() => {
    dispatch(setAppLoading(loading));
    // eslint-disable-next-line
  }, [loading]);

  useEffect(() => {
    getEmergencyContact();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                updateEmergencyContact(emergencyContact);
              }}
            >
              <div className="form-group row">
                <label
                  htmlFor="phoneNumber"
                  className="col-sm-3 col-form-label font-weight-bold"
                >
                  เบอร์โทรฉุกเฉิน <span className="text-danger">*</span>
                </label>
                <div className="col-sm-4">
                  <input
                    id="phoneNumber"
                    type="text"
                    className="form-control"
                    placeholder="เบอร์โทรฉุกเฉิน"
                    value={emergencyContact.phoneNumber}
                    onChange={(e) => {
                      setEmergencyContact((prev) => ({
                        ...prev,
                        phoneNumber: e.target.value,
                      }));
                    }}
                    required
                  />
                </div>
              </div>

              <div className="form-group row">
                <label
                  htmlFor="label"
                  className="col-sm-3 col-form-label font-weight-bold"
                >
                  ชื่อ/ป้ายกำกับ
                </label>
                <div className="col-sm-4">
                  <input
                    id="label"
                    type="text"
                    className="form-control"
                    placeholder="ชื่อ/ป้ายกำกับ"
                    value={emergencyContact.label || ""}
                    onChange={(e) => {
                      setEmergencyContact((prev) => ({
                        ...prev,
                        label: e.target.value,
                      }));
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label
                  htmlFor="description"
                  className="col-sm-3 col-form-label font-weight-bold"
                >
                  คำอธิบายเพิ่มเติม
                </label>
                <div className="col-sm-4">
                  <textarea
                    id="description"
                    className="form-control"
                    placeholder="คำอธิบายเพิ่มเติม"
                    style={{
                      maxWidth: "100%",
                      minHeight: 100,
                    }}
                    value={emergencyContact.description || ""}
                    onChange={(e) => {
                      setEmergencyContact((prev) => ({
                        ...prev,
                        description: e.target.value,
                      }));
                    }}
                  ></textarea>
                </div>
              </div>

              <div className="form-group row">
                <label
                  htmlFor="isActive"
                  className="col-sm-3 col-form-label font-weight-bold"
                >
                  สถานะการใช้งาน
                </label>
                <div className="col-sm-4">
                  <div className="form-check form-switch">
                    <input
                      id="isActive"
                      className="form-check-input"
                      type="checkbox"
                      checked={emergencyContact.isActive ?? true}
                      onChange={(e) => {
                        setEmergencyContact((prev) => ({
                          ...prev,
                          isActive: e.target.checked,
                        }));
                      }}
                    />
                    <label className="form-check-label" htmlFor="isActive">
                      {emergencyContact.isActive ? "เปิดใช้งาน" : "ปิดใช้งาน"}
                    </label>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-3"></div>
                <div className="col-sm-4 text-right">
                  <button className="btn btn-primary" type="submit">
                    บันทึก
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingEmergencyContact;
